<template>
  <div>
    <!-- 第一步条件筛选 -->
    <div class="section-right-content-box" v-if="sendOutStep">
      <div class="top-title">第一步 筛选会员</div>
      <!-- 左侧边栏 -->
      <div class="clear-float">
        <!-- left -->
        <div class="left-hug">
          <!-- 场景筛选 -->
          <div class="left-item">
            <div class="left-item-top">
              <span class="span-title">场景筛选</span>
              <span class="span-small" v-if="oneState" @click="oneBtn(1)"
                >收起</span
              >
              <span class="span-small" v-if="!oneState" @click="oneBtn(1)"
                >展开</span
              >
            </div>
            <div class="left-small-hug" v-if="oneState">
              <div
                class="left-small-item"
                v-for="(item, index) in oneData.list"
                :key="index"
                @click="oneTabBtn(item, 1)"
                :style="{
                  'border-color': item.state ? changeColor : '',
                  color: item.state ? changeColor : '',
                }"
              >
                <p>{{ item.name }}</p>
                <img
                  v-if="item.state"
                  class="right-gou"
                  src="../../assets/images/right.png"
                  alt
                />
              </div>
            </div>
          </div>
          <!-- 基本属性 -->
          <div class="left-item">
            <div class="left-item-top">
              <span class="span-title">基本属性</span>
              <span class="span-small" v-if="twoState" @click="oneBtn(2)"
                >收起</span
              >
              <span class="span-small" v-if="!twoState" @click="oneBtn(2)"
                >展开</span
              >
            </div>
            <div class="left-small-hug" v-if="twoState">
              <div
                class="left-small-item"
                v-for="(item, index) in twoData.list"
                :key="index"
                @click="oneTabBtn(item, 2)"
                :style="{
                  'border-color': item.state ? changeColor : '',
                  color: item.state ? changeColor : '',
                }"
              >
                <p>
                  {{ item.name }}
                </p>
                <img
                  v-if="item.state"
                  class="right-gou"
                  src="../../assets/images/right.png"
                  alt
                />
              </div>
            </div>
          </div>
          <!-- 交易属性 -->
          <div class="left-item">
            <div class="left-item-top">
              <span class="span-title">交易属性</span>
              <span class="span-small" v-if="threeState" @click="oneBtn(3)"
                >收起</span
              >
              <span class="span-small" v-if="!threeState" @click="oneBtn(3)"
                >展开</span
              >
            </div>
            <div class="left-small-hug" v-if="threeState">
              <div
                class="left-small-item"
                v-for="(item, index) in threeData.list"
                :key="index"
                @click="oneTabBtn(item, 3)"
                :style="{
                  'border-color': item.state ? changeColor : '',
                  color: item.state ? changeColor : '',
                }"
              >
                <p>
                  {{ item.name }}
                </p>
                <img
                  v-if="item.state"
                  class="right-gou"
                  src="../../assets/images/right.png"
                  alt
                />
              </div>
            </div>
          </div>
          <!-- RFM模型属性 -->
          <div class="left-item">
            <div class="left-item-top">
              <span class="span-title">RFM 模型属性</span>
              <span class="span-small" v-if="fourState" @click="oneBtn(4)"
                >收起</span
              >
              <span class="span-small" v-if="!fourState" @click="oneBtn(4)"
                >展开</span
              >
            </div>
            <div class="left-small-hug" v-if="fourState">
              <div
                class="left-small-item"
                v-for="(item, index) in fourData.list"
                :key="index"
                @click="oneTabBtn(item, 4)"
                :style="{
                  'border-color': item.state ? changeColor : '',
                  color: item.state ? changeColor : '',
                }"
              >
                <p>
                  {{ item.name }}
                </p>
                <img
                  v-if="item.state"
                  class="right-gou"
                  src="../../assets/images/right.png"
                  alt
                />
              </div>
            </div>
          </div>
          <!-- 营销属性 -->
          <div class="left-item">
            <div class="left-item-top">
              <span class="span-title">营销属性</span>
              <span class="span-small" v-if="fiveState" @click="oneBtn(5)"
                >收起</span
              >
              <span class="span-small" v-if="!fiveState" @click="oneBtn(5)"
                >展开</span
              >
            </div>
            <div class="left-small-hug" v-if="fiveState">
              <div
                class="left-small-item"
                v-for="(item, index) in fiveData.list"
                :key="index"
                @click="oneTabBtn(item, 5)"
                :style="{
                  'border-color': item.state ? changeColor : '',
                  color: item.state ? changeColor : '',
                }"
              >
                <p>
                  {{ item.name }}
                </p>
                <img
                  v-if="item.state"
                  class="right-gou"
                  src="../../assets/images/right.png"
                  alt
                />
              </div>
            </div>
          </div>
          <!-- 积分属性 -->
          <div class="left-item">
            <div class="left-item-top">
              <span class="span-title">积分属性</span>
              <span class="span-small" v-if="sixState" @click="oneBtn(6)"
                >收起</span
              >
              <span class="span-small" v-if="!sixState" @click="oneBtn(6)"
                >展开</span
              >
            </div>
            <div class="left-small-hug" v-if="sixState">
              <div
                class="left-small-item"
                v-for="(item, index) in sixData.list"
                :key="index"
                @click="oneTabBtn(item, 6)"
                :style="{
                  'border-color': item.state ? changeColor : '',
                  color: item.state ? changeColor : '',
                }"
              >
                <p>
                  {{ item.name }}
                </p>
                <img
                  v-if="item.state"
                  class="right-gou"
                  src="../../assets/images/right.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="right-hug">
          <div class="right-content">
            <div v-for="(allItem, index) in chooseArr" :key="index">
              <!-- twoData -->
              <!-- 会员等级 -->
              <div
                class="right-small-hug"
                v-if="twoData.list[0].state && allItem == 'grade'"
              >
                <div class="right-small-top2 clear-float">
                  <span>会员等级</span>
                  <span
                    class="font_family icon-wenhaoyuanyiwenmianxing"
                    style="float:right;cursor: pointer;color: rgb(153,153,153);"
                    @click="sureCancel(twoData.list[0], index, 'gradeTip')"
                    >删除</span
                  >
                  <div
                    class="right-small-hug2"
                    style="border:1px solid #ccc;overflow:hidden"
                  >
                    <el-checkbox-group
                      v-model="grade"
                      @change="isNotShowTip('gradeTip')"
                    >
                      <el-checkbox
                        v-for="city in memberUser_all"
                        :label="city.value"
                        :key="city.value"
                      >
                        <span>{{ city.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <!-- 人群标签 -->
              <div
                class="right-small-hug"
                v-if="twoData.list[1].state && allItem == 'labels'"
              >
                <div class="right-small-top2 clear-float">
                  <span>人群标签</span>
                  <span
                    style="float: right;cursor: pointer;
                           color: rgb(153,153,153);"
                    @click="
                      sureCancel(twoData.list[1], index, 'labelTypeIdTip')
                    "
                    >删除</span
                  >
                  <el-select
                    v-model="labels.labelType"
                    placeholder="请选择"
                    size="small"
                    style="width: 110px;margin-left: 20px;"
                    @change="isNotShowTip('labelTypeIdTip')"  
                  >
                    <el-option
                        v-for="items in labels.labelTypeList"
                        :key="items.label"
                        :label="items.label"
                        :value="items.id"
                      ></el-option>
                  </el-select>
                </div>
              </div>
              <!-- 性别 -->
              <div
                class="right-small-hug"
                v-if="twoData.list[2].state && allItem == 'sex'"
              >
                <div class="right-small-top2 clear-float">
                  446688888
                </div>
              </div>
              <!-- 职业 -->
              <div
                class="right-small-hug"
                v-if="twoData.list[3].state && allItem == 'sex'"
              >
                <div class="right-small-top2 clear-float">
                  66889997745
                </div>
              </div>
              <!-- threeData -->
              <!-- 详细地址 -->
              <div 
                class="right-small-hug"
                v-if="threeData.list[0].state && allItem == 'addressList'" 
              >
               <div
                 v-for="(items,index) in addressList.chooseTime"  
                 :key="index"
               >
                <div class="right-small-top3 clear-float">
                  <span  class="span-left" v-if="index === 0">详细地址(人群)</span>
                    <el-select 
                      v-if="index!=0"
                      v-model="addressList.secondVal"
                      placeholder="请选择" 
                      size="small"
                      style="width:110px;margin-left:20px;"
                    >
                    <!-- 并且和或者 -->
                     <el-option
                       v-for="items in addressList.optionsAnother"
                       :key="items.label"
                       :label="items.label"
                       :value="items.id"
                     >
                     </el-option>
                    </el-select>
                    <!-- 指定或者排除 -->
                    <el-select
                        v-model="items.labelValue"
                        size="small"
                        style="width: 110px;margin-left: 20px;"  
                    >
                    <el-option
                          v-for="item in items.labelOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                    </el-select>
                    <!-- 删除 -->
                    <span
                        class="font_family icon-shanchu"
                        style="float: right;cursor: pointer;color: rgb(153,153,153);"
                        @click="sureCancel(threeData.list[0],index)"
                        v-if="index === 0"
                   >删除</span>
                   <!-- 添加 -->
                   <!-- <span
                        class="font_family icon-tianjia"
                        style="margin-left: 10px;cursor: pointer;color: rgb(153,153,153);"
                        v-if="index === 0"
                        @click="newAddSelectTime(addressList,'chooseTime','address')"
                  >添加</span> -->
                  <!-- 图标删除 -->
                  <!-- <span
                        class="font_family icon-shanchu1"
                        style="margin-left: 10px;cursor: pointer;color: rgb(153,153,153);color: red"
                        @click="deleteBorthdayTime(addressList.chooseTime,index)"
                        v-else
                  ></span> -->
                </div>
                 <div class="right-small-hug2">
                   <el-radio 
                     v-model="items.addressRadio"
                     v-for="(item,indexs) in items.addressOptions"
                     :key="indexs"
                     :label="item.value"
                     style="vertical-align: top;margin-top: 7px;"        
                   >
                      {{item.name}}
                   </el-radio>
                   <div class="clear-float input-div">
                     <div>
                       <div style="vertical-align: top;">
                         <el-input
                            size="small"
                            v-model="items.defineVal"
                            placeholder="学校，幼儿园，小学，中学，高中，大学，院校，学院，教育局" 
                            @change="isNotShowTip('addressTip')"
                         >
                         </el-input>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>   
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第二步发送短信 -->
    <div></div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "",
  data() {
    return {
      sendOutStep: true,
      //左侧遍历数据
      oneState: true, //展开收起
      twoState: true,
      threeState: true,
      fourState: true,
      fiveState: true,
      sixState: true,
      //场景营销
      oneData: {
        list: [
          {
            name: "活跃客户",
            value: 1,
            state: false,
          },
          {
            name: "沉睡客户",
            value: 2,
            state: false,
          },
          {
            name: "流失客户",
            value: 3,
            state: false,
          },
          {
            name: "双十一客户",
            value: 4,
            state: false,
          },
          {
            name: "6.18客户",
            value: 5,
            state: false,
          },
        ],
      },
      //基本属性
      twoData: {
        list: [
          {
            name: "会员等级",
            value: 1,
            state: false,
            valDataName: "grade",
          },
          {
            name: "人群标签",
            value: 2,
            state: false,
            valDataName: "labels",
          },
          {
            name: "性别",
            value: 3,
            state: false,
            valDataName: "sex",
          },
          {
            name: "职业",
            value: 4,
            state: false,
            valDataName: "crowdPortraitType",
          },
          {
            name: "生日",
            value: 5,
            state: false,
            valDataName: "birthdayList",
          },
          {
            name: "年龄",
            value: 6,
            state: false,
          },
          {
            name: "QQ",
            value: 7,
            state: false,
          },
          {
            name: "微信",
            value: 8,
            state: false,
          },
          {
            name: "旺旺昵称",
            value: 9,
            state: false,
          },
          {
            name: "买家姓名",
            value: 10,
            state: false,
          },
          {
            name: "星座",
            value: 11,
            state: false,
          },
          {
            name: "邮箱",
            value: 12,
            state: false,
          },
          {
            name: "所在地区气温",
            value: 13,
            state: false,
          },
          {
            name: "省市",
            value: 14,
            state: false,
          },
          {
            name: "首次入会时间",
            value: 15,
            state: false,
          },
        ],
      },
      //交易属性
      threeData: {
        list: [
          {
            name: "详细地址",
            state: false,
            value:1,
            valDataName:"addressList"
          },
          {
            name: "邮费",
            state: false,
          },
          {
            name: "订单查询",
            state: false,
          },
        ],
      },
      //详细的地址数据
      addressList:{
        secondVal:0,
        optionsAnother: this.sureOr_all, //下拉选择并且或者条件
        chooseTime:[
         {
            addressRadio:"",
            defineVal:"",
            value: "",
                addressOptions: [
              {
                name: "找学生/教师",
                value: "学校,小学,中学,高中,大学,院校"
              },
              {
                name: "找白领",
                value: "大楼,大厦,公司,广场,写字楼"
              },
              {
                name: "找公务员",
                value: "政府,机构,局,所,办公厅,委员会,检察院,法院"
              },
              {
                name: "找IT人员",
                value: "软件园,科技开发区,信息,工业园"
              },
              {
                name: "找金融族",
                value: "银行,证券,财务,信用社"
              },
              {
                name: "找居家族",
                value: "单元,小区,社区,栋,号,新村,家属院"
              },
              {
                name: "找医护人员",
                value: "医院,诊所,妇幼院"
              },
              {
                name: "自定义",
                value: ""
              }
            ],
            labelValue: 0,
            labelOptions: [
              {
                id: 0,
                label: "指定"
              },
              {
                id: 2,
                label: "排除"
              }
            ]
          }
        ]
      },
      //RFM模型属性
      fourData: {
        list: [
          {
            name: "第一次下单时间",
            state: false,
          },
          {
            name: "第一次付款时间",
            state: false,
          },
          {
            name: "第一次成功时间",
            state: false,
          },
          {
            name: "最后下单时间",
            state: false,
          },
          {
            name: "最后付款时间",
            state: false,
          },
          {
            name: "最后成功时间",
            state: false,
          },
          {
            name: "成功次数",
            state: false,
          },
          {
            name: "下单休眠时间",
            state: false,
          },
          {
            name: "成功休眠时间",
            state: false,
          },
          {
            name: "下单次数",
            state: false,
          },
          {
            name: "客户复购周期",
            state: false,
          },
          {
            name: "退款成功次数",
            state: false,
          },
          {
            name: "客单价",
            state: false,
          },
          {
            name: "客件数",
            state: false,
          },
          {
            name: "成功交易额",
            state: false,
          },
          {
            name: "退款成功金额",
            state: false,
          },
          {
            name: "付款休眠时间",
            state: false,
          },
          {
            name: "交易主动关闭次数",
            state: false,
          },
          {
            name: "交易主动关闭金额",
            state: false,
          },
        ],
      },
      //营销属性
      fiveData: {
        list: [
          {
            name: "短信营销复购",
            state: false,
          },
          {
            name: "短信营销次数",
            state: false,
          },
          {
            name: "最后短信营销时间",
            state: false,
          },
          {
            name: "短信营销休眠天数",
            state: false,
          },
          {
            name: "营销链接点击客户",
            state: false,
          },
          {
            name: "聚划算敏感度",
            state: false,
          },
          {
            name: "万人团敏感度",
            state: false,
          },
          {
            name: "链接最后点击时间",
            state: false,
          },
        ],
      },
      //积分属性
      sixData: {
        list: [
          {
            name: "开卡时间",
            state: false,
          },
          {
            name: "最近积分变更时间",
            state: false,
          },
          {
            name: "积分余额",
            state: false,
          },
          {
            name: "签到次数",
            state: false,
          },
          {
            name: "参与大转盘次数",
            state: false,
          },
          {
            name: "兑换积分次数",
            state: false,
          },
          {
            name: "兑换次数",
            state: false,
          },
          {
            name: "积分消耗",
            state: false,
          },
          {
            name: "是否完善资料",
            state: false,
          },
        ],
      },
      //左侧遍历数据
      chooseArr: [],
      //会员等级
      grade: [],
      //人群标签
      labels:{
        labelType: 0,
        labelTypeList: [
          {
            id: 0,
            label: "指定"
          },
          {
            id: 2,
            label: "排除"
          },
          {
            id:3,
            label: "为空"
          }
        ]
      }
    };
  },
  props: {},
  components: {},
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted() {},
  methods: {
    //左侧栏展开收回
    oneBtn(type) {
      if (type === 1) {
        this.oneState = !this.oneState;
      } else if (type === 2) {
        this.twoState = !this.twoState;
      } else if (type === 3) {
        this.threeState = !this.threeState;
      } else if (type === 4) {
        this.fourState = !this.fourState;
      } else if (type === 5) {
        this.fiveState = !this.fiveState;
      } else if (type === 6) {
        this.sixState = !this.sixState;
      } else {
      }
    },
    //场景营销点击侧边栏属性
    oneTabBtn(value, type) {
      console.log("场景营销点击侧边栏属性", value, type);
      // 点击场景营销--展开收起（对应筛选条件的内容板块）
      switch (type) {
        case 1:
          this.oneState = true;
          this.fourState = true;
          this.twoState = false;
          this.threeState = false;
          this.fiveState = false;
          this.sixState = false;
          break;
        case 2:
          this.oneState = false;
          this.twoState = true;
          this.threeState = true;
          this.fourState = true;
          this.fiveState = true;
          this.sixState = true;
          this.sevenState = true;
          break;
      }
      //把点击的属性值放到右边
      if (type == 1) {
      } else if (type == 2) {
        this.chooseAnother(this.oneData.list);
        this.dataForEach(this.twoData.list, value);
      }else if(type==3){
        this.chooseAnother(this.oneData.list);
        this.dataForEach(this.threeData.list, value);
      }
      //添加右边属性函数
      //  this.chooseDataRight();
    },
    //右侧属性
    dataForEach(arr, value) {
      //如果左边有选中的，再次点击的时候去除的方法
      let that = this,
        chooseA = that.chooseArr,
        _fn = function(a, obj) {
          var index = a.indexOf(obj);
          if (index > -1) {
            //大于-1就是包含
            a.splice(index, 1);
          }
          return a;
        };
      arr.forEach(function(item) {
        if (item.value == value.value) {
          //如果是选中的情况下，再次点击的时候就是去除
          if (item.state) {
            item.state = false;
            _fn(chooseA, item.valDataName);
          } else {
            //点击左侧栏的时候,右侧显示。
            item.state = true;
            //添加到右边的元素
            that.chooseArr.unshift(item.valDataName);
            console.log("888888", that.chooseArr);
          }
        }
      });
    },
    //遍历右侧是否有选中的条件
    chooseDataRight() {
      let vm = this,
        one = vm.oneData.list,
        two = vm.twoData.list,
        three = vm.threeData.list,
        four = vm.fourData.list,
        five = vm.fiveData.list,
        six = vm.sixData.list,
        seven = vm.sevenData.list,
        allArr = one
                 .concat(two)
                 .concat(three),
      //   .concat(three)
      //   .concat(four)
      //   .concat(five)
      //   .concat(six)
      //   .concat(seven),
      _fnObj = function(obj) {
        if (obj.state) {
          vm.empty = false;
        } else {
          vm.empty = true;
        }
      },
      _fn = function(arr) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].state) {
              vm.empty = false;
              return true;
            } else {
              _fnObj(arr[i]);
            }
          }
        };
      _fn(allArr);
    },
    //选择场景营销以外模块场景营销取消选中
    chooseAnother(arr) {
      for (var i = 0; i < arr.length; i++) {
        arr[i].state = false;
      }
    },
    //右边标签图标删除按钮
    sureCancel(obj, index, _tip) {
      console.log("1111", obj);
      console.log("1111", index);
      console.log("1111", _tip);
      let that = this,
        value = obj,
        arr = this.chooseArr; //这个将名字添加到右边元素dataForEach里边的 that.chooseArr.unshift(item.valDataName);
      obj.state = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == obj.valDataName) {
          arr.splice(i, 1);
        }
      }
    },
    //各个标签判断提示语
    isNotShowTip(_val) {
      console.log("88888", _val);
      let app = ["1", "2", "3"];
      let vmads = this.twoData.list.concat(app);
      console.log("8888999", vmads);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  background-color: #fff;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 33px 30px 16px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 1150px;
  margin: 20px;
  .left-hug {
    //left
    width: 354px;
    min-width: 250px;
    min-height: 500px;
    border: 1px solid rgba(239, 239, 239, 1);
    float: left;
    padding-bottom: 20px;
    .left-item {
      margin-bottom: 2px;
      .left-item-top {
        height: 45px;
        background: rgba(244, 245, 249, 1);
        line-height: 45px;
        padding: 0 32px;
        overflow: hidden;
        .span-title {
          float: left;
          font-size: 20px;
          font-weight: 500;
          line-height: 45px;
          color: rgba(51, 51, 51, 1);
        }
        .span-small {
          font-size: 14px;
          font-weight: 400;
          line-height: 45px;
          color: rgba(109, 112, 136, 1);
          float: right;
          cursor: pointer;
        }
      }
      .left-small-hug {
        padding: 16px 8px;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        .left-small-item {
          float: left;
          width: 33%;
          height: 28px;
          margin-right: 1px;
          margin-bottom: 4px;
          border: 1px solid #dcdcdc;
          opacity: 1;
          border-radius: 2px;
          text-align: center;
          line-height: 28px;
          font-size: 13px;
          font-weight: 400;
          color: #606060;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          p {
            margin: 0;
            padding: 0;
          }
          .right-gou {
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
      }
    }
  }
  .right-hug {
    margin-left: 26%;
    .right-content {
      width: 80%;
      margin-left: 5%;
    }
    .right-small-hug {
      border: 1px solid rgba(109, 112, 136, 0.2);
      opacity: 1;
      border-radius: 2px;
      margin-bottom: 25px;
      .right-small-top2 {
        height: 40px;
        background: rgba(244, 245, 249, 1);
        line-height: 40px;
        padding-left: 22px;
        padding-right: 13px;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .right-small-hug2 {
        line-height: 32px;
        font-size: 14px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        padding: 5px 20px;
        span {
          color: #606266;
        }
      }
      .right-small-top3 {
       line-height: 40px;
       font-family: "Microsoft YaHei";
       font-weight: 400;
       padding-left: 20px;
       padding-right: 15px;
       height: 40px;
       overflow: hidden;
       background: #f5f8fa;
      .three-left {
        float: left;
        width: 115px;
      }
     }
    }
  }
}
//标题字体
.top-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  padding-bottom: 20px;
}
/*清除浮动代码*/
.clear-float:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.span-left {
  width: 133px;
  display: block;
  float: left;
}
.input-div {
      display: inline-block;
      width: 66%;
      .msg {
        margin-top: 5px;
        width: 160px;
        height: 30px;
        background: rgba(255, 118, 0, 0.1);
        line-height: 30px;
      }
      input {
      }
}
</style>
